module.exports = __webpack_public_path__ + "static/media/avatar.55e0652f.jpg";